'use client';

import React, { memo, PropsWithChildren, useEffect } from 'react';

import { useIsMobile } from '@repo/ui/hooks/use-mobile';

import { YtVideoCardAnalysisBottomSheet } from './yt-video-card-analysis-bottom-sheet';
import {
  useYtVideoCardAnalysis,
  YtVideoCardAnalysisIntentProvider,
} from './yt-video-card-analysis-intent-context';
import { YtVideoCardAnalysisSidebar } from './yt-video-card-analysis-sidebar';

interface YtVideoCardAnalysisWrapperProps extends PropsWithChildren {
  videoId: string;
  isShared?: boolean;
}

const PureYtVideoCardAnalysisWrapperContent: React.FC<
  YtVideoCardAnalysisWrapperProps
> = ({ children, videoId }) => {
  const isMobile = useIsMobile();
  const { isOpen, setIsOpen } = useYtVideoCardAnalysis();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'CLOSE_SIDEBAR') {
        setIsOpen(false);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [setIsOpen]);

  if (isMobile) {
    return (
      <YtVideoCardAnalysisBottomSheet
        videoId={videoId}
        open={isOpen}
        setOpen={setIsOpen}
      >
        {children}
      </YtVideoCardAnalysisBottomSheet>
    );
  }
  return (
    <YtVideoCardAnalysisSidebar
      videoId={videoId}
      open={isOpen}
      setOpen={setIsOpen}
    >
      {children}
    </YtVideoCardAnalysisSidebar>
  );
};

const PureYtVideoCardAnalysisWrapper: React.FC<
  YtVideoCardAnalysisWrapperProps
> = ({ children, videoId, isShared = false }) => {
  return (
    <YtVideoCardAnalysisIntentProvider initialOpen={isShared}>
      <PureYtVideoCardAnalysisWrapperContent videoId={videoId}>
        {children}
      </PureYtVideoCardAnalysisWrapperContent>
    </YtVideoCardAnalysisIntentProvider>
  );
};

export const YtVideoCardAnalysisWrapper = memo(PureYtVideoCardAnalysisWrapper);
